"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TwoMediaLayout = require("./TwoMediaLayout");
Object.keys(_TwoMediaLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TwoMediaLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TwoMediaLayout[key];
        }
    });
});
var _OneMediaParagraphTextLayout = require("./OneMediaParagraphTextLayout");
Object.keys(_OneMediaParagraphTextLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _OneMediaParagraphTextLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _OneMediaParagraphTextLayout[key];
        }
    });
});
